import React from "react";
import { Button, Box } from "@mui/material";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

const DownloadButtons = ({ transactions }) => {
  const downloadCSV = () => {
    const csvContent = [
      ["Transaction ID", "Receiver ID", "Reverse By", "Receiver Name", "User Type", "Amount", "Date", "Remark", "Opening Balance", "Closing Balance", "Status"],
      ...transactions.map((txn) => [
        txn.tId,
        txn.receiverId,
        txn.reverseBy,
        txn.receiverName,
        txn.utype,
        txn.amount,
        txn.dt,
        txn.remark || "N/A",
        txn.userWltOpeningBlc,
        txn.userWltClosingBlc,
        txn.status,
      ]),
    ]
      .map((e) => e.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "transactions.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(transactions);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Transactions");
    XLSX.writeFile(wb, "transactions.xlsx");
  };

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.text("Transaction Details", 20, 10);
    doc.autoTable({
      head: [["Transaction ID", "Receiver ID", "Reverse By", "Receiver Name", "User Type", "Amount", "Date", "Remark", "Opening Balance", "Closing Balance", "Status"]],
      body: transactions.map((txn) => [
        txn.tId,
        txn.receiverId,
        txn.reverseBy,
        txn.receiverName,
        txn.utype,
        txn.amount,
        txn.dt,
        txn.remark || "N/A",
        txn.userWltOpeningBlc,
        txn.userWltClosingBlc,
        txn.status,
      ]),
    });
    doc.save("transactions.pdf");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
        marginBottom: "1rem",
        flexWrap: "wrap", // Ensures responsiveness on smaller screens
      }}
    >
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#027BFE",
          color: "white",
          textTransform: "none",
          borderRadius: "8px",
          padding: "8px 16px",
          "&:hover": { backgroundColor: "#0056b3" },
        }}
        onClick={downloadCSV}
      >
        Download CSV
      </Button>
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#28a745",
          color: "white",
          textTransform: "none",
          borderRadius: "8px",
          padding: "8px 16px",
          "&:hover": { backgroundColor: "#218838" },
        }}
        onClick={downloadExcel}
      >
        Download Excel
      </Button>
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#dc3545",
          color: "white",
          textTransform: "none",
          borderRadius: "8px",
          padding: "8px 16px",
          "&:hover": { backgroundColor: "#c82333" },
        }}
        onClick={downloadPDF}
      >
        Download PDF
      </Button>
    </Box>
  );
};

export default DownloadButtons;
